/**
 * The reasons a reference can be flagged out of a request in the Reference Retrieval Queue.
 *
 * Flagging is always per request (`RequestPatent.isInvalid` / `invalidReason`), never against
 * the patent globally - the same reference requested again arrives unflagged and the user
 * chooses afresh.
 *
 * The codes must stay in step with the backend catalog, reference_downloader_apis
 * `utils/invalidReasons.js`, which owns validation and the wording used in the ZIP error
 * list and the completion email. Adding a reason is one entry in each: the flag menu and
 * the row chip both render from this array.
 */
export const INVALID_REASONS = [
  { code: "INVALID_REFERENCE", label: "Invalid Reference" },
  { code: "KIND_CODE_NOT_AVAILABLE", label: "Not Available at Source with Requested Kind Code" },
];

// References flagged before the reason was recorded come back with invalidReason = null and
// have to keep reading as the original "Invalid Reference".
export const DEFAULT_INVALID_REASON_CODE = "INVALID_REFERENCE";

/**
 * Maps a stored reason onto a code this build knows. Null (legacy rows) and any code from a
 * backend running ahead of this catalog resolve to the default, so the UI shows the old
 * wording rather than an empty chip or an unmarked menu.
 */
export const resolveInvalidReasonCode = (code) =>
  INVALID_REASONS.some((r) => r.code === code) ? code : DEFAULT_INVALID_REASON_CODE;

/** Label for a stored reason code, resolved as above. */
export const getInvalidReasonLabel = (code) =>
  INVALID_REASONS.find((r) => r.code === resolveInvalidReasonCode(code)).label;
